"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateKeyLenException = void 0;
const tslib_1 = require("tslib");
const ErrorCode_1 = tslib_1.__importDefault(require("./ErrorCode"));
class PrivateKeyLenException extends Error {
    constructor() {
        super('Private key has invalid length');
        this.code = ErrorCode_1.default.ParameterInvalid;
    }
}
exports.PrivateKeyLenException = PrivateKeyLenException;
exports.default = {
    PrivateKeyLenException,
};
//# sourceMappingURL=privateKey.js.map